import { render } from "./AccountPotentialSelect.vue?vue&type=template&id=875468ec"
import script from "./AccountPotentialSelect.vue?vue&type=script&lang=js"
export * from "./AccountPotentialSelect.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/src/CRM/OutlookAddin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__